(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Tabbed-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initTabbedCollection(section) {
    if (section.dataset.tabsInitialized) return;
    section.dataset.tabsInitialized = 'true';
    const tabs = Array.from(section.querySelectorAll('.tab'));
    const panels = Array.from(section.querySelectorAll('.tab-content'));
    const carousels = Array.from(section.querySelectorAll('.carousel'));

    function selectTab(tab) {
      const panel = panels.find(item => item.id === tab.dataset.tab);
      if (!panel) return;
      tabs.forEach(item => {
        const selected = item === tab;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(item => item.classList.toggle('active', item === panel));
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        selectTab(tabs[next]);
        tabs[next].focus();
        tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
      });
    });

    section.querySelectorAll('.carousel-arrow').forEach(arrow => {
      arrow.addEventListener('click', () => {
        const carousel = carousels.find(item => item.id === arrow.dataset.target);
        if (!carousel) return;
        const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
        const direction = arrow.classList.contains('left') ? -1 : 1;
        const left = Math.min(maxScroll, Math.max(0, carousel.scrollLeft + direction * 240));
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        carousel.scrollTo({ left, behavior });
      });
    });
  }

  function initWithin(root) {
    if (root.matches && root.matches('.tabbed-collections')) initTabbedCollection(root);
    root.querySelectorAll('.tabbed-collections').forEach(initTabbedCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preorder-by-month"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".preorder-by-eta .tab");
  const contents = document.querySelectorAll(".preorder-by-eta .tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      tab.classList.add("active");
      const targetId = tab.getAttribute("data-tab");
      const target = document.getElementById(targetId);
      if (target) {
        target.classList.add("active");

        // 移除 scrollIntoView，防止跳躍
        const carousel = target.querySelector(".product-carousel");
        if (carousel) {
          carousel.scrollLeft = 0; // 每次切換歸 0
          updateArrows(carousel);
        }
      }
    });
  });

  function updateArrows(carousel) {
    const wrapper = carousel.closest(".product-carousel-wrapper");
    const leftArrow = wrapper.querySelector(".carousel-arrow.left");
    const rightArrow = wrapper.querySelector(".carousel-arrow.right");

    const scrollLeft = carousel.scrollLeft;
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;

    if (scrollLeft <= 0) {
      leftArrow.classList.add("disabled");
    } else {
      leftArrow.classList.remove("disabled");
    }

    if (scrollLeft >= maxScroll - 1) {
      rightArrow.classList.add("disabled");
    } else {
      rightArrow.classList.remove("disabled");
    }
  }

  // 初始化與滾動更新
  document.querySelectorAll(".product-carousel").forEach(carousel => {
    const wrapper = carousel.closest(".product-carousel-wrapper");

    wrapper.querySelectorAll(".carousel-arrow").forEach(arrow => {
      arrow.addEventListener("click", () => {
        const direction = arrow.getAttribute("data-direction");
        const scrollAmount = 240 * 1; // 滾動 1 張卡片寬度

        if (direction === "left") {
          carousel.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        } else {
          carousel.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }

        setTimeout(() => updateArrows(carousel), 400); // 延遲更新箭頭狀態
      });
    });

    carousel.addEventListener("scroll", () => updateArrows(carousel));

    // 初始狀態
    updateArrows(carousel);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
